module.exports = __webpack_public_path__ + "static/media/trafficlightyellow.2bed1ffa.png";